import { API_URL } from '@/config';

export const logout = (): Promise<null> => {
  // ほかのアプリからもログアウトするためにOIDCログアウトURLにリダイレクト
  const oidcLogoutUrl = buildOidcLogoutUrl();
  window.location.href = oidcLogoutUrl;
  return Promise.resolve(null);
};

function buildOidcLogoutUrl(): string {
  const oidcProviderBase = API_URL;
  const postLogoutRedirectUri = encodeURIComponent(window.location.origin);

  return `${oidcProviderBase}/oauth/logout?post_logout_redirect_uri=${postLogoutRedirectUri}`;
}
